import type { CannotTransmitReason } from '@faks/shared';
import type { Attachment } from 'types/api/attachment';
import type { PharmacyRefusedReasons } from 'types/api/pharmacies/trades/trade_instance';
import type { CompleteTradeItem } from 'types/api/trades';
import type { TradeRequirement } from './trade';
import type { TradesInstancePayment } from './trades_instance_payment';

export const tradesInstanceStatus = [
  'subscribed',
  'validated_by_group',
  'awaiting_validation_by_group',
  'refused_by_group',
  'validated_by_lab',
  'refused_by_lab',
  'awaiting_validation_by_lab',
  'closed',
  'refused_by_pharmacy',
  'paid',
  'payment_processing',
  'compensated_outside_faks',
] as const;

export type TradesInstanceStatus = (typeof tradesInstanceStatus)[number];

export type TradeInstanceExtendedStatus =
  | TradesInstanceStatus
  | 'ongoing'
  | 'to_change'
  | 'expired'
  | 'not_subscribed';

export type LabTradeInstanceExtendedStatus =
  | TradesInstanceStatus
  | 'awaiting_validation_by_faks'
  | 'partially_compensated';

export type InvoiceGenerationStatus = 'pending' | 'processing' | 'finished' | 'failed';

export const tradesInstanceSource = [
  'faks',
  'elsie_intranet',
  'totum_intranet',
  'opeaz',
  'apri_trade',
  'my_trade_leadersante',
  'stimdata',
  'mediprix',
  'other',
] as const;
export type TradesInstanceSource = (typeof tradesInstanceSource)[number];

export interface TradeRequirementInstance {
  id: number;
  attachments: Attachment[] | null;
  trades_requirement_id: number;
  trades_instance_id: number;
  created_by_user_id: number;
  sellout_total_item_quantities: number;
  sellout_total_item_sales_in_euros_cents: number;
  pharmacy_provided_compensation_in_euro_cents: number | null;
  sellout_items_count: number;
  trades_requirement: TradeRequirement;
}

export interface TradeInstance {
  id: number;
  created_at: string;
  updated_at: string;
  validated_refused_at: string | null;
  validated_refused_by_user_info: string | null;
  compensated_at: string | null;
  compensated_by_user_info: string | null;
  status: TradesInstanceStatus;
  group_refused_reason: string | null;
  pharmacy_id: number;
  trade_id: number;
  trades_requirements_instances: TradeRequirementInstance[];
  trade: CompleteTradeItem;
  lab_refused_reason: string | null;
  pharmacy_refused_reason: PharmacyRefusedReasons | null;
  pharmacy_refused_reason_message: string | null;
  pharmacist_comment: string | null;
  trades_instance_payment: TradesInstancePayment | null;
  compensation_in_euro_cents: number | null;
  validated_compensation_in_euro_cents: number | null;
  overriden_compensation_in_euro_cents: number | null;
  calculated_compensation_in_euro_cents: number | null;
  compensated_by_user_id: number | null;
  created_by_user_id: number;
  validated_refused_by_user_id: number | null;
  source: TradesInstanceSource;
  transmitted_to_platform: boolean;
  transmitted_at: string | null;
  auto_transmit_at: string | null;
  auto_transmitted: boolean;
  transmitted_by_id: number | null;
  cannot_transmit_reason: CannotTransmitReason | null;
  proofs_unchanged_since_refusal: boolean;
}
